<template>
  <vs-card>
    <form role="form" @submit.stop.prevent="exportReport">
      <vs-row class="filtroConsolidado">
        <vs-col class="lg:w-1/3 w-full mb-4">
          <label class="labelFiltro">Data Inicial</label>
          <DatePicker
            id="Data Inicial"
            name="Data Inicial"
            class="w-full"
            v-model="filters.startDate"
            format="DD/MM/YYYY"
            placeholder="DD/MM/YYYY"
            value-type="format"
            :editable="true"
            :lang="lang"
            v-mask="'##/##/####'"
            data-testId="start-date-picker"
            v-validate="{
              required: true,
              validDate: true,
              isTodayLessOrSameThan: true,
            }"
            :input-class="['mx-input', veeErrors.has('Data Inicial') ? 'has-error' : '']"
          />
          <span
            v-show="veeErrors.has('Data Inicial')"
            class="text-danger"
            data-testId="start-date-error"
          >
            {{ dangerText('Data Inicial') }}
          </span>
        </vs-col>
        <vs-col class="lg:w-1/3 w-full mb-4">
          <label class="labelFiltro">Data Final</label>
          <DatePicker
            id="Data Final"
            name="Data Final"
            class="w-full"
            v-model="filters.endDate"
            format="DD/MM/YYYY"
            placeholder="DD/MM/YYYY"
            value-type="format"
            :editable="true"
            :lang="lang"
            v-mask="'##/##/####'"
            data-testId="end-date-picker"
            v-validate="{
              required: true,
              validDate: true,
              isTodayLessOrSameThan: true,
              daysRange: true,
              isEndDateSameOrAfter: true,
            }"
            :input-class="['mx-input', veeErrors.has('Data Final') ? 'has-error' : '']"
          />
          <span
            v-show="veeErrors.has('Data Final')"
            class="text-danger"
            data-testId="end-date-error"
          >
            {{ dangerText('Data Final') }}
          </span>
        </vs-col>
        <vs-col class="lg:w-1/3 w-full mb-4">
          <label class="labelFiltro">Forma de Pagamento</label>
          <v-select
            clearable
            multiple
            v-model="filters.paymentForms"
            class="w-full"
            :options="paymentForms"
            id="Forma de Pagamento"
            name="Forma de Pagamento"
            label="label"
            data-testid="payment-form"
            :reduce="(option) => option.value"
          ></v-select>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col class="lg:w-1/3 w-full mb-4">
          <label class="labelFiltro">Adquirente</label>
          <v-select
            clearable
            multiple
            v-model="filters.acquirers"
            class="w-full"
            :options="acquirerOptions"
            id="Adquirente"
            name="Adquirente"
            label="label"
            data-testid="acquirer"
            :reduce="(option) => option.value"
          ></v-select>
        </vs-col>
        <vs-col v-if="showConvenants" class="lg:w-1/3 w-full mb-4">
          <label class="labelFiltro">Convênio</label>
          <v-select
            clearable
            multiple
            v-model="filters.covenants"
            class="w-full"
            :options="covenants"
            id="Status da Apólice"
            label="label"
            data-testid="statuses"
            :reduce="(option) => option.id"
          ></v-select>
        </vs-col>
        <vs-col v-if="showConsultancies" class="lg:w-1/3 w-full mb-4">
          <label class="labelFiltro">Assessoria</label>
          <v-select
            clearable
            multiple
            v-model="filters.consultancies"
            class="w-full"
            :options="consultancies"
            id="Status da Apólice"
            label="label"
            data-testid="statuses"
            :reduce="(option) => option.id"
          ></v-select>
        </vs-col>
        <vs-col v-if="showBrokers" class="lg:w-1/3 w-full mb-4">
          <label class="labelFiltro">Corretora</label>
          <v-select
            clearable
            multiple
            v-model="filters.brokers"
            class="w-full"
            :options="brokers"
            id="Status da Apólice"
            label="label"
            data-testid="statuses"
            :reduce="(option) => option.id"
          ></v-select>
        </vs-col>
      </vs-row>
      <vs-row vs-align="flex-end" vs-justify="flex-end" vs-w="12">
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
          <div class="flex justify-end mt-4">
            <vs-button
              color="#038803"
              type="filled"
              icon-pack="feather"
              icon="icon-download"
              icon-after
              vs-w="2"
              class="pt-4 pb-4 mb-4 mt-2 mr-3 sm:mt-0"
              native-type="submit"
              :disabled="isFormValid"
              >Gerar Relatório
            </vs-button>
          </div>
        </vs-col>
      </vs-row>
    </form>
  </vs-card>
</template>
<script>
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import ptBr from 'vue2-datepicker/locale/pt-br';
import 'vue2-datepicker/index.css';
import moment from 'moment';

import reportsApi from '../../../../../services/reports.api';
import autoApi from '../../../../../services/auto.api';
import creditCardAcquirerApi from '../../../../../services/credit.card.acquirer.api';
import { PAYMENT_METHODS } from '../../../../../utils/constants';
import functions from '../../../../../utils/functions';
import notify from '../../../../../utils/notify';
import { Validator } from 'vee-validate';
import {
  isDifferenceDays,
  isEndDateSameOrAfter,
} from '../../../../../utils/customValidator';

export default {
  name: 'PaymentsReportFilter',
  components: {
    vSelect,
    DatePicker,
  },
  data() {
    const lang = ptBr;
    const maxDaysRange = 31;
    const paymentForms = [];
    const brokers = [];
    const consultancies = [];
    const covenants = [];
    const acquirerOptions = [];
    const filters = {
      startDate: '',
      endDate: '',
      paymentForms: [],
      brokers: [],
      consultancies: [],
      covenants: [],
      acquirers: [],
    };
    const { brokerId, consultancyId, convanantId } =
      functions.getDecoded(localStorage);
    return {
      lang,
      maxDaysRange,
      paymentForms,
      brokers,
      consultancies,
      covenants,
      acquirerOptions,
      brokerId,
      consultancyId,
      convanantId,
      filters,
    };
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.$validator.validateAll();
      },
    },
  },
  computed: {
    isFullReadingPermission() {
      return this.$can('Leitura Carteira Completa', 'Pagamentos');
    },
    showBrokers() {
      return (
        this.isFullReadingPermission || this.consultancyId || this.convanantId
      );
    },
    showConsultancies() {
      return this.isFullReadingPermission || this.convanantId;
    },
    showConvenants() {
      return this.isFullReadingPermission;
    },
    isFormValid() {
      return this.$validator.errors.any();
    },
  },
  created() {
    Validator.extend('daysRange', {
      getMessage: () =>
        `O periodo deve ser de no máximo ${this.maxDaysRange} dias`,
      validate: (value) =>
        isDifferenceDays(this.filters.startDate, value, this.maxDaysRange),
    });
    Validator.extend('isEndDateSameOrAfter', {
      getMessage: () => `A data final deve ser maior que a data inicial`,
      validate: (value) => isEndDateSameOrAfter(this.filters.startDate, value),
    });
  },
  mounted() {
    this.getContext();
    this.getPaymentMethods();
    this.getAcquirers();
  },
  methods: {
    dangerText(field) {
      const errorMessage = this.veeErrors.items.find(
        (item) => item.field === field,
      );

      return errorMessage ? errorMessage.msg : '';
    },
    async getContext() {
      const callGetFullContext = () => reportsApi.getFullContext();
      const callGetUserContext = () => reportsApi.getUserContext();
      const data = this.isFullReadingPermission
        ? await callGetFullContext()
        : await callGetUserContext();
      this.brokers = data.brokers;
      this.consultancies = data.consultancies;
      this.covenants = data.covenants;
    },
    async getPaymentMethods() {
      const paymentMethods = await autoApi.getPaymentMethods();
      this.paymentForms = paymentMethods.map((paymentMethod) => ({
        label: paymentMethod.paymentName,
        value: paymentMethod.id,
      }));
    },
    async getAcquirers() {
      const acquirers = await creditCardAcquirerApi.getAcquirers(
        PAYMENT_METHODS.CREDIT_CARD.id,
      );
      this.acquirerOptions = acquirers.map((acquirer) => ({
        label: acquirer.name,
        value: acquirer.id,
      }));
    },
    async exportReport() {
      const isValidFields = await this.$validator.validateAll();

      if (!isValidFields) {
        notify.notifyFail(this.$vs, 'Preencha todos os campos obrigatórios');
        return;
      }

      const start = moment(this.filters.startDate, 'DD/MM/YYYY').toDate();
      const end = moment(this.filters.endDate, 'DD/MM/YYYY').toDate();

      const startDate = start.toISOString().split('T')[0] + 'T00:00:00';
      const endDate = end.toISOString().split('T')[0] + 'T23:59:59';
      this.$emit('export', {
        ...this.filters,
        startDate,
        endDate,
      });
    },
  },
};
</script>
